export default {
	TITLE_GROUPS: 'Tile layout groups',
	TITLE_GROUP_TRANSLATIONS: 'Tile layout group translations',
	BATCH_ADD: 'Click to add',

	MODAL_TITLE: 'Add tile layout group translation',
	NAME: 'Name',
	NAME_PLACEHOLDER: 'Enter name...',
	LANGUAGE: 'Language',
	LANGUAGE_PLACEHOLDER: 'Select language...',
	SUBMIT: 'Submit',
	ADD_ROW_TOOLTIP: 'Add row',
};
